import { capitalize, toUpper } from 'lodash';

export const capitalizeAll = (str: string): string => str
  .split(' ').map((item) => capitalize(item)).join(' ');

export const isParseValid = (str: string) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

// eslint-disable-next-line no-useless-escape
export const getFileExtension = (url: string): string => url.split('.').pop()?.split(/\#|\?/)[0] || '';


export const createActionTypeToResource = (actionType: string): string => {
  const str = actionType
    .replace('CREATE_', '')
    .replace('_SUCCESS', '')
    .replace('_', ' ')
    .toLowerCase();

  return capitalize(str);
};

export const toMoneyFormat = (currency: string, amount: number): string => {

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: toUpper(currency),
    minimumFractionDigits: 2,
  });

  return formatter.format(amount);
};
